export default {

    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    label: {
        margin: "0px 0px 0px 4px",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "17px",
        color: "#262626"
    }
}